import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import {OpenDataComponent} from './open-data/open-data.component';
import {LicenzaComponent} from './licenza/licenza.component';
import {FAQComponent} from './faq/faq.component';
import {PrivacyPolicyComponent} from './privacy-policy/privacy-policy.component';
import {ContattiComponent} from './contatti/contatti.component';
import {PubblicazioniComponent} from './pubblicazioni/pubblicazioni.component';

const routes: Routes = [
  {path: 'licenza', component: LicenzaComponent},
  {path: 'open-data', component: OpenDataComponent},
  {path: 'FAQ', component: FAQComponent},
  {path: 'privacy-policy', component: PrivacyPolicyComponent},
  {path: 'contatti', component: ContattiComponent},
  {path: 'pubblicazioni', component: PubblicazioniComponent},
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PagesRoutingModule { }
